module.exports = __webpack_public_path__ + "media/images/flags/32/Papua-New-Guinea-8823dd6ffe50e5639aebabffff8ee135.png";